import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import rootReducer from '@/store/rootReducer';

type RootState = ReturnType<typeof rootReducer>;

interface State {
  /**
   * 상태로 관리할 서버 파일 목록
   */
  freshWorkFiles: ImageFile[];
  /**
   * 삭제 요청을 보낼 서버 파일 목록
   */
  staleWorkFiles: ImageFile[];
}

export const getInitialState = (): State => ({
  freshWorkFiles: [],
  staleWorkFiles: [],
});

const workFileStore = createSlice({
  name: 'workFile',
  initialState: getInitialState(),
  reducers: {
    /**
     * 정기/일회성 작업 상세의 서버 파일을 상태 관리 목록에 추가합니다.
     */
    addFreshWorkFiles(state, { payload }: PayloadAction<ImageFile[]>) {
      const hashTable = Object.create(null);
      state.freshWorkFiles.concat(payload).forEach((file) => {
        if (!hashTable[file.id]) {
          hashTable[file.id] = file;
        }
      });
      state.freshWorkFiles = Object.values(hashTable);
    },
    /**
     * 정기/일회성 작업 상세의 서버 파일을 상태 관리 목록에서 제거하고,
     * 삭제 요청을 보낼 작업 파일 목록(staleWorkFiles)에 추가합니다.
     */
    deleteFreshWorkFile(state, { payload }: PayloadAction<ImageFile>) {
      state.freshWorkFiles = state.freshWorkFiles.filter(
        (freshFile) => freshFile.id !== payload.id
      );
      state.staleWorkFiles = state.staleWorkFiles.concat(payload);
    },
    /***
     * 서버 파일의 상태 관리를 해제합니다.
     */
    initWorkFiles(state) {
      state.freshWorkFiles = [];
      state.staleWorkFiles = [];
    },
  },
});

export const workFilesSelector = (state: RootState) => ({
  freshWorkFiles: state.workFile.freshWorkFiles,
  staleWorkFiles: state.workFile.staleWorkFiles,
});

export const workFileStoreActions = workFileStore.actions;

export default workFileStore.reducer;
